import { openUrlInNewTab } from '@anecdotes/utils';
import { inject, Injectable } from '@angular/core';
import Smooch from 'smooch';
import { APP_CONFIG } from '@anecdotes/configuration-data-access';

@Injectable()
export class SmoochSdkFacade {
  private readonly appConfig = inject(APP_CONFIG);

  async initAsync(): Promise<void> {
    const config = window['__AnPlatformConfiguration__'];

    await Smooch.init({
      integrationId: config.smooch.integrationId,
      businessIconUrl: 'apps/assets/anecdotes_logo.png',
      businessName: 'anecdotes',
      buttonIconUrl: 'apps/assets/chat_trigger.png',
      buttonWidth: '42',
      buttonHeight: '42',
      prechatCapture: {
        enabled: false,
      },
      customColors: {
        brandColor: '053956',
        actionColor: '6D778A',
        conversationColor: '009FB5',
      },
      menuItems: {
        imageUpload: true,
        fileUpload: true,
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  open(message?: string): void {
    // *** TEMPORARY TURNED OFF ***
    // Smooch.open();
    // if (message) {
    //   Smooch.setPredefinedMessage(message);
    //   return;
    // }

    openUrlInNewTab(this.appConfig.redirectUrls.supportLink);
  }
}
